import {
    CHART_DESKTOP_WIDTH,
    CHART_HEIGHT,
    CHART_MOBILE_WIDTH,
    FONT_SIZE,
} from "./constants";
import graphStyles from "./Graphs.module.scss";
import { TemperatureCurves, TemperaturePoints } from "./useTemperatureData";
import weatherStyles from "./Weather.module.scss";

export type TemperatureGraphProps = TemperatureCurves &
    TemperaturePoints & {
        minTemps: number[];
        maxTemps: number[];
    };

export const TemperatureGraph: React.FC<TemperatureGraphProps> = ({
    minTemps,
    maxTemps,
    minTempPoints,
    maxTempPoints,
    minTempsCurve,
    maxTempsCurve,
}) => {
    return (
        <>
            <svg
                viewBox={`0 0 ${CHART_DESKTOP_WIDTH} ${CHART_HEIGHT}`}
                className={weatherStyles.desktop}
            >
                <g>
                    <path
                        d={maxTempsCurve}
                        className={graphStyles["max-path"]}
                    />
                    {maxTempPoints.map(({ x, y }, index) => (
                        <text
                            textAnchor="middle"
                            key={index}
                            x={x}
                            y={y - 16} // TEXT_OFFSET
                            fontSize={FONT_SIZE}
                            className={graphStyles["max-points"]}
                        >
                            {Math.floor(maxTemps[index])}&deg;
                        </text>
                    ))}
                </g>
                <g>
                    <path
                        d={minTempsCurve}
                        className={graphStyles["min-path"]}
                    />
                    {minTempPoints.map(({ x, y }, index) => (
                        <text
                            key={index}
                            textAnchor="middle"
                            x={x}
                            y={y + 26} // TEXT_OFFSET
                            className={graphStyles["min-points"]}
                            fontSize={FONT_SIZE}
                        >
                            {Math.floor(minTemps[index])}&deg;
                        </text>
                    ))}
                </g>
            </svg>
            <svg
                viewBox={`0 0 ${CHART_MOBILE_WIDTH} ${CHART_HEIGHT}`}
                className={weatherStyles.mobile}
            >
                <g>
                    <path
                        d={maxTempsCurve}
                        className={graphStyles["max-path"]}
                    />
                    {maxTempPoints.map(({ x, y }, index) => (
                        <text
                            textAnchor="middle"
                            key={index}
                            x={x}
                            y={y - 16} // TEXT_OFFSET
                            className={graphStyles["max-points"]}
                            fontSize={12}
                        >
                            {Math.floor(maxTemps[index])}&deg;
                        </text>
                    ))}
                </g>
                <g>
                    <path
                        d={minTempsCurve}
                        className={graphStyles["min-path"]}
                    />
                    {minTempPoints.map(({ x, y }, index) => (
                        <text
                            key={index}
                            textAnchor="middle"
                            x={x}
                            y={y + 26} // TEXT_OFFSET
                            className={graphStyles["min-points"]}
                            fontSize={12}
                        >
                            {Math.floor(minTemps[index])}&deg;
                        </text>
                    ))}
                </g>
            </svg>
        </>
    );
};
